import React from 'react';
import { InputNumber } from 'antd';
import { numberInputFormatter, numberInputParser } from '../variables/constants';

// Drop-in remplaçant pour <InputNumber> d'AntD avec séparateurs de milliers
// activés par défaut. Le formatter/parser peuvent être surchargés.
export default function CBInputNumber({ formatter, parser, ...rest }) {
  return (
    <InputNumber
      formatter={formatter ?? numberInputFormatter}
      parser={parser ?? numberInputParser}
      {...rest}
    />
  );
}
